import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { CookieService } from 'ngx-cookie-service';
import { worklogM } from 'src/app/Models/BasicForms/worklogM';
import { ApiService } from 'src/app/Service/api.service';
import { differenceInCalendarDays, setHours } from 'date-fns';
import { DisabledTimeFn, NzDatePickerComponent } from 'ng-zorro-antd/date-picker';
import * as moment from 'moment';

@Component({
  selector: 'app-worklog-drawer',
  templateUrl: './worklog-drawer.component.html',
  styleUrls: ['./worklog-drawer.component.css'],
  providers: [DatePipe]
})

export class WorklogDrawerComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: worklogM;
  @Input() typeData: number;
  @Input() typeIDData: number;

  @Input() estimatedTime_Mandays: any;

  @Input() estimatedHH: any;
  @Input() estimatedMM: any;
  @Input() estimatedSS: any;

  @Input() estimatedMandays: any;

  constructor(public _apiService: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe, public cookie: CookieService) { }

  ngOnInit(): void { }

  isSpinning = false;
  logtext: string = "";

  save(addNew: boolean, worklogPage: NgForm): void {
    var isOk = true;

    if (this.data.WORKED_DATETIME != undefined) {
      if (this.data.WORKED_DATETIME == null) {
        isOk = false;
        this.notificationService.error("Please Select Start Date Time", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Select Start Date Time", "");
    }

    if (this.data.END_DATETIME != undefined) {
      if (this.data.END_DATETIME == null) {
        isOk = false;
        this.notificationService.error("Please Select End Date Time", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Select End Date Time", "");
    }

    // if (this.data.SPENT_HOURS != undefined) {
    //   if (this.data.SPENT_HOURS == null || this.data.SPENT_HOURS == 0) {
    //     isOk = false;
    //     this.notificationService.error("Spent Hour(s) is Not Valid", "");
    //   }
    // } else {
    //   isOk = false;
    //   this.notificationService.error("Spent Hour(s) is Not Valid", "");
    // }

    // if (this.data.SPENT_MINUTES != undefined) {
    //   if (this.data.SPENT_MINUTES == null || this.data.SPENT_MINUTES == 0) {
    //     isOk = false;
    //     this.notificationService.error("Spent Minute(s) is Not Valid", "");
    //   }
    // } else {
    //   isOk = false;
    //   this.notificationService.error("Spent Minute(s) is Not Valid", "");
    // }

    // if (this.data.SPENT_SECONDS != undefined) {
    //   if (this.data.SPENT_SECONDS == null || this.data.SPENT_SECONDS == 0) {
    //     isOk = false;
    //     this.notificationService.error("Spent Second(s) is Not Valid", "");
    //   }
    // } else {
    //   isOk = false;
    //   this.notificationService.error("Spent Second(s) is Not Valid", "");
    // }

    if (this.data.SPENT_HOURS == 0 && this.data.SPENT_MINUTES == 0 && this.data.SPENT_SECONDS == 0) {
      isOk = false;
      this.notificationService.error("Please Enter Valid Spent Time", "");
    }

    if (this.data.WORK_DESCRIPTION != undefined) {
      if (this.data.WORK_DESCRIPTION.trim() == '') {
        isOk = false;
        this.notificationService.error("Please Enter Valid Work Description", "");
      }
    } else {
      isOk = false;
      this.notificationService.error("Please Enter Valid Work Description", "");
    }

    if (isOk) {
      this.isSpinning = true;
      this.data.USER_ID = this._apiService.userId;
      this.data.TYPE = this.typeData;
      this.data.TYPE_ID = this.typeIDData;
      this.data.IS_ACTIVE = true;

      this.data.WORKED_DATETIME = this.datePipe.transform(this.data.WORKED_DATETIME, "yyyy-MM-dd HH:mm") + ":00";
      this.data.START_DATETIME = this.datePipe.transform(this.data.WORKED_DATETIME, "yyyy-MM-dd HH:mm") + ":00";
      this.data.END_DATETIME = this.datePipe.transform(this.data.END_DATETIME, "yyyy-MM-dd HH:mm") + ":00";
      this.data.PROJECT_ID = sessionStorage.getItem('projectID');



      if (!this.data.ID) {
        this._apiService.createWorklog(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Worklog Added Successfully", "");

            if (!addNew) {
              this.close(worklogPage);

              this.logtext = 'Save & Close - Worklog Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Worklog Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });

            } else {
              this.resetDrawer(worklogPage);
              this.data = new worklogM();

              this.logtext = 'Save & New - Worklog Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Worklog Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });
            }
            this.isSpinning = false;

          } else {
            this.notificationService.error("Failed to Add Worklog", "");
            this.logtext = 'Save & Close - Worklog Master form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Worklog Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });

      } else {
        this._apiService.updateWorklog(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Worklog Updated Successfully", "");
            this.logtext = 'Update & Close - Worklog Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Worklog Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });

            this.isSpinning = false;
            this.drawerClose();

          } else {
            this.notificationService.error("Failed to Update Worklog", "");
            this.logtext = 'Update & Close - Worklog Master form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Worklog Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });
      }
    }
  }

  close(worklogPage: NgForm) {
    this.drawerClose();
    this.resetDrawer(worklogPage);
  }

  resetDrawer(worklogPage: NgForm) {
    worklogPage.form.reset();
  }

  today = new Date();
  timeDefaultValue = setHours(new Date(), 0);

  disabledStartDate = (current: Date): boolean =>
    differenceInCalendarDays(current, this.today) > 0;


  // dates = ['2022-04-15', '2022-04-10', '2022-04-11', '2022-04-12', '2022-04-13', '2022-04-14'];
  dates = [];

  disabledEndDate = current => {
    let index = this.dates.findIndex(date => date === moment(current).format('YYYY-MM-DD'))
    return index === -1 && true
  }

  disabledDateTime: DisabledTimeFn = () => ({
    nzDisabledHours: () => [],
    nzDisabledMinutes: () => [],
    nzDisabledSeconds: () => []
  });

  startTimeInMilliseconds = 0;
  endTimeInMilliseconds = 0;
  tempStartDate: Date = null;

  sDateChange() {

    var startDate = new Date(this.data.WORKED_DATETIME);


    startDate.setMilliseconds(0);
    startDate.setSeconds(0);

    this.startTimeInMilliseconds = startDate.getTime();


    if (this.startTimeInMilliseconds > 0) {
      this.dates = [];
      this.dates.push(this.datePipe.transform(this.data.WORKED_DATETIME, "yyyy-MM-dd"));


      // 

      this.tempStartDate = new Date(this.data.WORKED_DATETIME);


    } else {
      this.dates = [];


      this.tempStartDate = null;

    }
  }

  // getDaysArray(start, end) {
  //   for (var arr = [], dt = new Date(start); dt <= new Date(end); dt.setDate(dt.getDate() + 1)) {
  //     arr.push(this.datePipe.transform(dt, "yyyy-MM-dd"));
  //   }
  //   return arr;
  // };

  eDateChange() {

    var endDate = new Date(this.data.END_DATETIME);


    endDate.setMilliseconds(0);
    endDate.setSeconds(0);

    this.endTimeInMilliseconds = endDate.getTime();

  }

  startDateChange() {
    this.sDateChange();
  }

  endDateChange() {
    this.sDateChange();
    this.eDateChange();
    this.getDifference(this.startTimeInMilliseconds, this.endTimeInMilliseconds)
  }

  getDifference(startTime, endTime) {
    var Difference_In_Time = endTime - startTime;
    if (Difference_In_Time > 0) {
      var seconds = Math.floor((Difference_In_Time / 1000) % 60);
      var minutes = Math.floor((Difference_In_Time / (1000 * 60)) % 60);
      var hours = Math.floor((Difference_In_Time / (1000 * 60 * 60)) % 24);
      var days = Math.floor(Difference_In_Time / (1000 * 60 * 60 * 24));

      if (hours < 10) { hours = 0 + hours; }
      if (minutes < 10) { minutes = 0 + minutes; }
      if (seconds < 10) { seconds = 0 + seconds; }

      this.data.SPENT_HOURS = (days * 24) + hours;
      this.data.SPENT_MINUTES = minutes;
      this.data.SPENT_SECONDS = seconds;

    } else {
      this.data.SPENT_HOURS = 0;
      this.data.SPENT_MINUTES = 0;
      this.data.SPENT_SECONDS = 0;
    }
  }

  @ViewChild('moduleEndDatePicker') moduleEndDatePicker: NzDatePickerComponent;

  moduleStartDateHandle(open: boolean) {
    if (!open) {
      this.moduleEndDatePicker.open();
    }
  }

  moduleEndDateHandle(open: boolean) {
    if (open) {
      if (this.tempStartDate != null) {
        this.data.END_DATETIME = this.tempStartDate;
      }

      // if (this.data.WORKED_DATETIME != null || this.data.END_DATETIME != undefined) {
      //   this.data.END_DATETIME = this.data.WORKED_DATETIME;
      // }

      if (this.data.END_DATETIME == null || this.data.END_DATETIME == undefined) {
        this.data.END_DATETIME = new Date();

      } else {
        this.data.END_DATETIME = this.data.END_DATETIME;
      }
    }



  }
}
